import React, { useEffect, useState } from 'react';

const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : '/api');

export default function AcceptInvite() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [inviteData, setInviteData] = useState(null);
  
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    
    if (!token) {
      setError('Enlace inválido o incompleto.');
      setLoading(false);
      return;
    }

    // Validate token
    fetch(`${API_URL}/invite/validate?token=${token}`)
      .then(res => res.json().then(data => ({ status: res.status, data })))
      .then(({ status, data }) => {
        if (status === 200) {
          setInviteData({ ...data, token });
        } else {
          setError(data.error || 'Invitación inválida o caducada.');
        }
      })
      .catch(() => setError('Error de red al validar invitación.'))
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    
    setIsSubmitting(true);
    setError('');
    
    try {
      const res = await fetch(`${API_URL}/invite/accept`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: inviteData.token, password })
      });
      const data = await res.json();
      
      if (res.ok) {
        setSuccess(true);
        // Redirect to login after 3 seconds
        setTimeout(() => {
          window.location.href = '/app';
        }, 3000);
      } else {
        setError(data.error || 'Error al procesar la invitación');
      }
    } catch (err) {
      setError('Error de conexión con el servidor.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-color)' }}>
        <p style={{ color: 'white' }}>Validando invitación...</p>
      </div>
    );
  }

  if (error && !success) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-color)', padding: '1rem' }}>
        <div className="glass-panel" style={{ padding: '3rem', textAlign: 'center', maxWidth: '500px', width: '100%' }}>
          <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'rgba(239, 68, 68, 0.2)', color: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem auto', fontSize: '2rem' }}>
            !
          </div>
          <h2 className="text-xl" style={{ marginBottom: '1rem' }}>Enlace Inválido</h2>
          <p className="text-muted" style={{ marginBottom: '2rem' }}>{error}</p>
          <a href="/" style={{ padding: '0.8rem 2rem', background: 'rgba(255,255,255,0.1)', color: 'white', textDecoration: 'none', borderRadius: '8px' }}>Volver al inicio</a>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-color)', padding: '1rem' }}>
        <div className="glass-panel" style={{ padding: '3rem', textAlign: 'center', maxWidth: '500px', width: '100%' }}>
          <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'rgba(16, 185, 129, 0.2)', color: 'var(--health-green)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem auto', fontSize: '2rem' }}>
            ✓
          </div>
          <h2 className="text-xl" style={{ marginBottom: '1rem' }}>¡Cuenta Activada!</h2>
          <p className="text-muted">Tu cuenta ha sido creada y vinculada correctamente a <strong>{inviteData.trainerName}</strong>.</p>
          <p style={{ marginTop: '2rem', fontSize: '0.9rem', color: 'var(--text-muted)' }}>Redirigiendo a la aplicación...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-color)', padding: '1rem' }}>
      <div className="glass-panel" style={{ padding: '3rem', maxWidth: '500px', width: '100%', animation: 'fadeInTab 0.4s ease-out' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 className="text-2xl text-gradient" style={{ marginBottom: '0.5rem' }}>Bienvenido al equipo</h1>
          <p className="text-muted">
            <strong>{inviteData.trainerName}</strong> te ha invitado a unirte a su programa de entrenamiento.
          </p>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.02)', padding: '1.5rem', borderRadius: '12px', border: '1px solid var(--glass-border)', marginBottom: '2rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
            <span className="text-muted text-sm">Tu Nombre</span>
            <span style={{ color: 'white' }}>{inviteData.name}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span className="text-muted text-sm">Tu Email</span>
            <span style={{ color: 'white' }}>{inviteData.email}</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div>
            <label style={{ display: 'block', fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '0.5rem' }}>
              Elige una contraseña para tu cuenta
            </label>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Contraseña segura"
              required
              minLength={6}
              style={{
                width: '100%', padding: '1rem', borderRadius: '8px', border: '1px solid var(--glass-border)',
                background: 'rgba(255,255,255,0.05)', color: 'white', outline: 'none'
              }}
            />
          </div>

          {error && (
            <div style={{ color: '#ef4444', fontSize: '0.875rem', background: 'rgba(239, 68, 68, 0.1)', padding: '0.8rem', borderRadius: '8px' }}>
              {error}
            </div>
          )}

          <button 
            type="submit" 
            disabled={isSubmitting}
            style={{
              width: '100%', padding: '1rem', background: 'var(--health-cyan)', color: 'black',
              border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '1rem',
              cursor: isSubmitting ? 'not-allowed' : 'pointer', transition: 'opacity 0.2s',
              opacity: isSubmitting ? 0.7 : 1
            }}
          >
            {isSubmitting ? 'Activando...' : 'Activar mi cuenta'}
          </button>
        </form>
      </div>
    </div>
  );
}
